import React, { useState } from "react";
import { Tab, Nav, Card } from "react-bootstrap";
import GeneralInfo from "./forms/GeneralInfo";
import ProfilePhoto from "./forms/ProfilePhoto";
import CoverPhoto from "./forms/CoverPhoto";
import AccountType from "./forms/AccountType";
import { useProfileContext } from "provider/ProfileProvider";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "provider/ToastProvider";
import { useAuth } from "provider/AuthContext";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import AlertModal from "../AlertModal";
import { useAlertContext } from "provider/AlertProvider";

const ProfileSettingsTabs = ({ genInfoSubmit, profilePhotoSubmit, coverPhotoSubmit }) => {
  const { show, actionType, alertDispatch } = useAlertContext();
  console.log("actionType",actionType)
  const { activeTab, profileDispatch } = useProfileContext();
  const [loading, setLoading] = useState(false);
  const { showErrorToast, showSuccessToast } = useToast();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleTabSelect = (key) => {
    profileDispatch({
      type: "SET_ACTIVE_TAB",
      payload: key
    });
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "general":
        return <GeneralInfo genInfoSubmit={genInfoSubmit} />;
      case "profile-photo":
        return <ProfilePhoto profilePhotoSubmit={profilePhotoSubmit} />;
      case "cover-photo":
        return <CoverPhoto coverPhotoSubmit={coverPhotoSubmit} />;
      case "account-type":
        return <AccountType />;
      default:
        return null;
    }
  };

  const deactivateAccount = async () => {
    try {
      setLoading(true);
      const response = await apiCall({
        url: "deactivate-account",
        method: "POST",
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const errors = apiData.errors;
        // Dynamically set errors based on the response
        Object.keys(errors).forEach((key) => {
          const errorMessages = errors[key];
          const firstErrorMessage = errorMessages[0];
          // Set the error state for the corresponding field
          showErrorToast(firstErrorMessage)

        });
        return;
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        setTimeout(() => {
          logout();
        }, 1500);
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Optionally show error UI feedback here
      handleError(error, logout, navigate);

    } finally {

      profileDispatch({
        type: "SET_GEN_INFO_LOADING",
        payload: false
      });
      alertDispatch({
        type: "ALERT_MODAL_TOGGLE",
        payload: false,
      });
    }
  };

  const deleteAccount = async () => {
    try {
      setLoading(true);
      const response = await apiCall({
        url: "request-delete-account",
        method: "POST",
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }

      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const errors = apiData.errors;
        // Dynamically set errors based on the response
        Object.keys(errors).forEach((key) => {
          const errorMessages = errors[key];
          const firstErrorMessage = errorMessages[0];
          // Set the error state for the corresponding field
          showErrorToast(firstErrorMessage)

        });
        return;
      }
      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        setTimeout(() => {
          logout();
        }, 1500);
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);
      // Optionally show error UI feedback here
      handleError(error, logout, navigate);

    } finally {

      profileDispatch({
        type: "SET_GEN_INFO_LOADING",
        payload: false
      });
    }
  };

  const onShow = (action) => {
    let content = null
    if (action === 'deactivateAccount') {
      content = <>
        <p><span className="text-danger">Important:</span> Your account will be deactivated immediately. Our system will process the permanent deletion of all your data over the next 90 days. After this 90-day period, your account and all associated information will be permanently removed.</p>
        <p>If you are a partner, your partner profile will also be deactivated immediately, and your data will be permanently deleted during this 90-day period.</p>

        <p>
          Do you wish to continue with this account deletion request?
        </p>
      </>
    } else if (action === 'deleteAccount') {
      content = <>
        <p><span className="text-danger">Important:</span> Your account will be deactivated immediately. Our system will process the permanent deletion of all your data over the next 90 days. After this 90-day period, your account and all associated information will be permanently removed.</p>
        <p>If you are a partner, your partner profile will also be deactivated immediately, and your data will be permanently deleted during this 90-day period.</p>

        <p>
          Do you wish to continue with this account deletion request?
        </p>
      </>
    }
    alertDispatch({
      type: "ALERT_MODAL_TOGGLE",
      payload: {
        show: true,
        content: content,
        actionType: action
      },
    });
  }


const handleConfirm = (actionType) => {
  console.log("actionType", actionType)
  switch (actionType) {
    case 'deactivateAccount':
      // Call your deactivateAccount logic
      deactivateAccount();
      break;

    case 'deleteAccount':
      // Call your deleteAccount logic
      deleteAccount();
      break;

    default:
      console.warn(`Unknown action type: ${actionType}`);
      break;
  }
};

  return (
    <>
      <Card className="account-settingside safartabs">
        <Card.Body className="p-4">
          <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
             <div className="overflow-auto w-100 hide-scrollbar">
            <Nav
              className="nav nav-tabs mb-4 slider_accountsetting border-bottom d-flex gap-2 flex-nowrap"
              role="tablist"
            >
              <Nav.Item role="presentation">
                <Nav.Link eventKey="general">General Information</Nav.Link>
              </Nav.Item>
              <Nav.Item role="presentation">
                <Nav.Link eventKey="profile-photo">Profile Photo</Nav.Link>
              </Nav.Item>
              <Nav.Item role="presentation">
                <Nav.Link eventKey="cover-photo">Cover Photo</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item role="presentation">
              <Nav.Link eventKey="account-type">Account Type</Nav.Link>
            </Nav.Item> */}
            </Nav>
            </div>

            <div className="form-inputssetting">{renderActiveTab()}</div>
          </Tab.Container>
        </Card.Body>
      </Card>
      <Card className="account-settingside safartabs mt-3">
        <Card.Body className="p-4">
          <div className="float-start">
            <div className="safari text-center">
              <div className="joinsafari leavesafrai">
                <Link
                  onClick={(e) => {
                    if (loading) {
                      e.preventDefault();
                      return;
                    }
                    // deleteAccount(e)
                    onShow('deleteAccount');
                  }}
                  disabled={loading}
                >
                  Delete Account
                </Link>
              </div>
            </div>
          </div>
          <div className="float-end">
            <div className="safari text-center">
              <div className="joinsafari leavesafrai">
                <Link
                  onClick={(e) => {
                    if (loading) {
                      e.preventDefault();
                      return;
                    }
                    onShow('deactivateAccount');
                  }}
                  disabled={loading}
                >
                  Deactivate Account
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>

      {show && <AlertModal
        onConfirm={() => handleConfirm(actionType)}
        title="Alert"
        confirmText="Yes"
      />
       
       
    
      }
    </>
  );
};

export default ProfileSettingsTabs;
